import { FC } from 'react'
import { isBefore, isSameDay, subDays } from 'date-fns'

import { Card, Spinner } from 'ui'

import { t } from 'translations'

type Props = {
  isLoading: boolean
  date: Date
}

const NoEvent: FC<Props> = ({ date, isLoading }) => {
  const isToday = isSameDay(new Date(), date)
  const isBeforeToday = isBefore(date, subDays(new Date(), 1))

  return (
    <Card className={`mb-1 ${isToday ? 'primary-border' : ''}`} style={{ opacity: isBeforeToday ? 0.5 : 1 }}>
      <Card.Body className={'p-2 align-items-center'}>
        <div>
          <span className={`text-center${isToday ? '' : ' text-muted font-italic'}`}>
            {isLoading ? (
              <>
                <Spinner size="sm" /> {t('employee.mySchedule.LOADING_SHIFTS')}
              </>
            ) : (
              t(`employee.mySchedule.NO_SHIFTS${isToday ? '_TODAY' : ''}`)
            )}
          </span>
        </div>
      </Card.Body>
    </Card>
  )
}

export default NoEvent
